import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { recommendationsStateSelector } from "../recommendationsStateSelector";

export const recommendationAppliedTypesSelector = createDraftSafeSelector(
  [recommendationsStateSelector],
  (state) => {
    return state.filters.types;
  },
);
